import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

// Some lazy loading...
const Home = () => import(/* webpackChunkName: "home" */ '@/views/Home.vue');
const Room = () => import(/* webpackChunkName: "room" */ '@/views/Room.vue');
const TablePoc = () => import('@/views/TablePoc.vue');

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/room/:roomId',
    name: 'PoqerRoom',
    component: Room,
    props: true // the props for the component will be filled with the params. Mention the name!
  },
  {
    path: '/tablepoc',
    name: 'TablePoc',
    component: TablePoc
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
